<div class="row row-cols-1 row-cols-md-2 g-2">
  <div class="col">
    <app-saved-filters [specs]="specs" [customTypes]="customSavedFilterTypes"></app-saved-filters>
  </div>
  <div class="col">
    <app-favourites [specs]="specs"></app-favourites>
  </div>
  <div class="col">
    <app-activity-stream [selectedTypes]="selectedTypes" [selectableTypes]="selectableTypes"></app-activity-stream>
  </div>
  <div class="col">
    <app-dashboard-changelog></app-dashboard-changelog>
  </div>
</div>
